import React from "react";
import LabelValue from "../../shared/custom/labelValue/LabelValue";
import { useDateCustom } from "../../shared/custom_use/useDateCustom";
import { useLanguageForShared } from "../../shared/utils/languages/useLanguageForShared";

const TemplateConcentratorPrescriptionRead = ({ data, prefix, title }: any) => {
  const { t } = useLanguageForShared();
  const { data: dataFormatter } = useDateCustom();
  const blockData = prefix ? data?.[prefix] || {} : data || {};
  const translateOrFallback = (key: string, fallback: string) => {
    const translated = t(key);
    return translated === key ? fallback : translated;
  };
  const getBlockValue = (key: string) => {
    if (!prefix) {
      return blockData?.[key];
    }

    return blockData?.[key] ?? data?.[`${prefix}.${key}`];
  };

  const getNumericValue = (key: string) => {
    const value = getBlockValue(key);

    if (value === undefined || value === null || value === "") {
      return 0;
    }

    const parsed = parseFloat(String(value).replace(",", "."));
    return isNaN(parsed) ? 0 : parsed;
  };

  const check24h =
    getNumericValue("flowRestHourDie") +
    getNumericValue("underStressFlowHourDie") +
    getNumericValue("nightFlowHourDie");

  const hasAnyHourValue = [
    getBlockValue("flowRestHourDie"),
    getBlockValue("underStressFlowHourDie"),
    getBlockValue("nightFlowHourDie")
  ].some((value) => value !== undefined && value !== null && value !== "");

  const transportableFlowType =
    data?.["transportable.flowType"] ?? data?.transportable?.flowType ?? "";

  const useLevel =
    prefix === "portable" ||
    (prefix === "transportable" && transportableFlowType === "pulsed");

  const flowRestLabel = useLevel
    ? translateOrFallback("prescription.template.levelRest", "A riposo | livello")
    : t("prescription.template.flowRest");
  const underStressLabel = useLevel
    ? translateOrFallback("prescription.template.levelUnderStress", "Sotto sforzo | livello")
    : t("prescription.template.underStressFlow");
  const nightLabel = useLevel
    ? translateOrFallback("prescription.template.levelNight", "Notturno | livello")
    : t("prescription.template.nightFlow");

  return (
    <>
      <div className="col-sm-12 col-md-12">
        <p className={"title-paragraph"}>{title || t('sg.prescription')}</p>

        <LabelValue label={flowRestLabel}
                                   value={getBlockValue("flowRest") || "-"} />
        {getBlockValue("flowContinue") !== undefined && <LabelValue label={t("prescription.template.flowContinue")}
                                           value={getBlockValue("flowContinue") || "-"} />}
        <LabelValue
          label={t("prescription.template.hourDie")}
          value={getBlockValue("flowRestHourDie") || "-"} className={"me-5"} />

        {getBlockValue("flowContinueHourDie") !== undefined && <LabelValue
          label={t("prescription.template.hourDie")}
          value={getBlockValue("flowContinueHourDie") || "-"} className={"me-5"} />}

        <><LabelValue
          label={underStressLabel}
          value={getBlockValue("underStressFlow") || "-"} />
          <LabelValue
            label={t("prescription.template.hourDie")}
            value={getBlockValue("underStressFlowHourDie") || "-"} />
        </>
        <><LabelValue
          label={nightLabel}
          value={getBlockValue("nightFlow") || "-"} />
          <LabelValue
            label={t("prescription.template.hourDie")}
            value={getBlockValue("nightFlowHourDie") || "-"} />
        </>
        {hasAnyHourValue && (
          <LabelValue
            label={t("prescription.template.check24h.label")}
            value={check24h}
          />
        )}
      </div>
    </>
  );
};

export default TemplateConcentratorPrescriptionRead;
